import toastr from 'toastr';

if (typeof toastr !== 'undefined') {
  toastr.options = {
    closeButton: false,
    debug: false,
    newestOnTop: false,
    progressBar: false,
    positionClass: 'toast-top-right',
    preventDuplicates: true,
    onclick: null,
    showDuration: '300',
    hideDuration: '1000',
    timeOut: '5000',
    extendedTimeOut: '1000',
    showEasing: 'swing',
    hideEasing: 'linear',
    showMethod: 'fadeIn',
    hideMethod: 'fadeOut',
  };
}

const defaultErrorMessage = 'If this continues, try reloading the page or contacting customer support for help.';

// Add toastr options to make alert box remain on screen
const addSticky = (options) => {
  return {
    ...options,
    ...{
      // Keep message on screen
      timeOut: 0,
      extendedTimeOut: 0,
      // Instead of clicking on message, require user click X to close it
      // which allows them to easier copy/paste error text for support
      tapToDismiss: false,
      closeButton: true,
    },
  };
};

const Notify = {
  success: (message = 'Saved', title = '', optionsOverride = {}) => toastr.success(message, title, optionsOverride),

  warning: (message = 'Processing', title = '', optionsOverride = {}) =>
    toastr.warning(message, title, optionsOverride),

  error: (message = defaultErrorMessage, title = 'Error', optionsOverride = {}) =>
    toastr.error(message, title, optionsOverride),

  /**
   * Display an error alert that remains on screen until the user clicks the X close button.
   */
  stickyError: (message = defaultErrorMessage, title = 'Error', options = {}) => {
    options = addSticky(options);
    toastr.error(message, title, options);
  },
};

export default Notify;
